// Voto delle ricette ("Com'è venuta?"): un clic su una stella invia il voto,
// il browser ricorda la scelta e le stelle restano accese. Votare di nuovo
// cambia il voto.
export function setupRating() {
  const box = document.querySelector('.recipe-rating');
  if (!box) return;
  const stars = [...box.querySelectorAll('.recipe-rating__star')];
  const thanks = box.querySelector('.recipe-rating__thanks');
  const avg = box.querySelector('.recipe-rating__avg');
  const trap = box.querySelector('.recipe-rating__trap');
  const key = box.dataset.ratingKey;
  let saved = 0;
  try { saved = Number(localStorage.getItem(key)) || 0; } catch (e) { /* niente localStorage */ }

  const paint = (n) => stars.forEach((star, i) => {
    star.classList.toggle('is-lit', i < n);
    star.setAttribute('aria-pressed', String(i < saved));
  });
  paint(saved);

  stars.forEach((star) => {
    const value = Number(star.dataset.value);
    star.addEventListener('mouseenter', () => paint(value));
    star.addEventListener('focus', () => paint(value));
    star.addEventListener('click', () => send(value));
  });
  box.querySelector('.recipe-rating__stars').addEventListener('mouseleave', () => paint(saved));

  function send(value) {
    const token = document.querySelector('meta[name="csrf-token"]');
    fetch(box.dataset.ratingUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json',
                 'X-CSRF-Token': token ? token.content : '' },
      body: JSON.stringify({ value, website: trap ? trap.value : '' })
    }).then((response) => {
      if (!response.ok) throw new Error(response.status);
      return response.status === 204 ? {} : response.json();
    }).then((data) => {
      saved = value;
      try { localStorage.setItem(key, String(value)); } catch (e) { /* niente localStorage */ }
      paint(saved);
      thanks.textContent = box.dataset.thanks;
      if (data.label) avg.textContent = data.label;
    }).catch(() => {
      paint(saved);
      thanks.textContent = box.dataset.error;
    });
  }
}
